import React, { createContext } from "react";

/**
 * The context containing the active client
 * @typedef {React.Context}
 */
export const ClientContext = createContext(null);
